module.exports = __webpack_public_path__ + "static/media/81.b1b54dc7.jpg";